import { REGION_TERNOPOL } from '../const/variables';
import { isUser } from '../services/AuthService';

const TERNOPOL_ADDITIONAL_INFO_PLACEHOLDER = 'Додаткова інформація (у випадку, якщо ви подаєте заяву на зарахування у декілька навчальних закладів, зазначте у цьому рядку, який з них для вас є пріоритетний)';

export const getAdditionalInfoPlaceholder = (accountDetails) => {
    return accountDetails.regionName === REGION_TERNOPOL && isUser() ?
        TERNOPOL_ADDITIONAL_INFO_PLACEHOLDER : '';
};